import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { AppState } from '../../../store';
import { rejectCall } from '../../../store/calls/callsApi';
import {
  acceptIncomingCall,
  clearIncomingCall,
} from '../../../store/calls/actionCreators';

// Global v2 incoming-call ring (OI-1564). Shows when MQTT delivered an incoming
// call and we're not already in one; Accept promotes it to the activeCall the
// modal/controller takes over.
export default function IncomingCallBannerV2() {
  const dispatch = useDispatch();
  const incomingCall = useSelector((s: AppState) => s.calls.incomingCall);
  const activeCall = useSelector((s: AppState) => s.calls.activeCall);
  const hubOwners = useSelector((s: AppState) => s.hubOwner.hubOwners);

  if (!incomingCall || activeCall) return null;

  const caller = hubOwners?.find(
    (o) => o.customer_id === incomingCall.callerCustomerId,
  );
  const callerName = caller
    ? `${caller.first_name ?? ''} ${caller.last_name ?? ''}`.trim()
    : `Customer ${incomingCall.callerCustomerId}`;

  const onAccept = () => dispatch(acceptIncomingCall(callerName));
  const onReject = () => {
    rejectCall(incomingCall.callId).catch((e) => console.error(e));
    dispatch(clearIncomingCall());
  };

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'fixed',
        top: 24,
        right: 24,
        zIndex: 1500,
        p: 2,
        minWidth: 300,
        borderRadius: 2,
      }}
    >
      <Typography variant="subtitle1" fontWeight={700}>
        Incoming video call
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {callerName}
      </Typography>
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button variant="outlined" color="error" onClick={onReject}>
          Decline
        </Button>
        <Button variant="contained" color="success" onClick={onAccept}>
          Accept
        </Button>
      </Box>
    </Paper>
  );
}
